!function (fun) {
  'function' == typeof define && define.amd ? define(fun) : fun()
}(function () {
  'use strict';

  /* --- Common - Start --- */

  const productOptionValueCustom = 'custom';

  const classHide = 'custom-il-hide',
    classErrorReq = 'custom-il-error-required';

  const selectorMainAtc = 'form.product-purchase-form';

  const dataAttrValInputted = "data-cil-val-inputted";

  //
  //

  function commonSaveInStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
    }

    sessionStorage.setItem(key, value);
  }

  function commonReadFromStorage(key) {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue !== null) {
      return savedValue;
    }

    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function commonRemoveFromStorge(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
    }

    sessionStorage.removeItem(key);
  }

  //

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  //
  //

  function commonSelectOptionLabel(label, productForm) {
    if (label) {
      const associatedInput = document.querySelector('#' + label.htmlFor);
      if (associatedInput) {
        associatedInput.checked = true;
      }

      if (productForm) {
        $(productForm).find(theme.OptionManager.selectors.multiOption).trigger('change.themeProductOptions');
      }
    }
  }

  /* --- Common - End --- */

  //
  //
  //
  //
  //

  /* --- Pincode Checker - Start --- */

  const mynpcPincodeLen = 6,
    storageKeyMynpcPincode = "mynpc_pincode";

  const mynpcInputCodeTextCheckState = 'Please enter PIN code to check delivery time & Pay on Delivery Availability',
    mynpcInputCodeTextUnserviceableState = 'Unfortunately we do not ship to your pincode',
    mynpcInvalidPincodeMsg = 'Please enter a valid pincode',
    mynpcPlsTryAgainMsg = 'Please try again',
    mynpcGetByPrefix = 'Get it by ';

  const classMynpcCheckState = 'mynpc-state-check',
    classMynpcServiceableState = 'mynpc-state-serviceable',
    classMynpcUnserviceableState = 'mynpc-state-unserviceable',
    classMynpcInputCodeTextError = 'mynpc-input-error',
    classMynpcHide = 'mynpc-hide';

  const selectorMynpcMainContainer = '.mynpc-container',
    selectorMynpcErrorContainer = '.mynpc-error-container',
    selectorMynpcErrorText = '.mynpc-error-text',
    selectorMynpcDeliveryForm = '.mynpc-check-delivery-form',
    selectorMynpcDeliveryFormCodeInput = '.mynpc-code-input',
    selectorMynpcCheckCodeButton = '.mynpc-check-code-button',
    selectorMynpcChangeCodeButton = '.mynpc-change-code-button',
    selectorMynpcInputCodeText = '.mynpc-input-code-text',
    selectorMynpcDeliveryInfoGetBy = '.mynpc-delivery-info-get-by',
    selectorMynpcDeliveryInfoItemTitle = '.mynpc-delivery-info-item-title';

  //
  //
  //

  function mynpcEnableInputCode(mainContainer) {
    var codeInput = mainContainer.querySelector(selectorMynpcDeliveryFormCodeInput);
    codeInput.disabled = false;
  }

  function mynpcDisableInputCode(mainContainer) {
    var codeInput = mainContainer.querySelector(selectorMynpcDeliveryFormCodeInput);
    codeInput.disabled = true;
  }

  //
  //

  function mynpcClearPincode(mainContainer) {
    mynpcRemoveSavedPincode();

    var codeInput = mainContainer.querySelector(selectorMynpcDeliveryFormCodeInput);
    codeInput.value = '';
  }

  //

  function mynpcShowErrorMsg(mainContainer, msg) {
    const errorContainer = mainContainer.querySelector(selectorMynpcErrorContainer);
    var errorText = mainContainer.querySelector(selectorMynpcErrorText);

    errorText.innerText = msg;

    errorContainer.classList.remove(classMynpcHide);
    setTimeout(function () {
      errorContainer.classList.add(classMynpcHide);
    }, 3000);
  }

  //
  //
  //

  function mynpcSwitchToCheckState(mainContainer) {
    mainContainer.classList.remove(classMynpcServiceableState);
    mainContainer.classList.remove(classMynpcUnserviceableState);
    mainContainer.classList.add(classMynpcCheckState);

    mynpcEnableInputCode(mainContainer);
    mynpcClearPincode(mainContainer);

    var inputCodeText = mainContainer.querySelector(selectorMynpcInputCodeText);
    inputCodeText.innerText = mynpcInputCodeTextCheckState;
    inputCodeText.classList.remove(classMynpcInputCodeTextError);
  }

  //
  //

  function mynpcSwitchToServiceableState(mainContainer, respJson) {
    var basicJson = respJson.data.basic;

    var getBy = mainContainer.querySelector(selectorMynpcDeliveryInfoGetBy);
    var getByTitle = getBy.querySelector(selectorMynpcDeliveryInfoItemTitle);
    getByTitle.innerText = mynpcGetByPrefix + mynpcGetFormattedDate(basicJson.delivery_in_days);

    mainContainer.classList.remove(classMynpcCheckState);
    mainContainer.classList.remove(classMynpcUnserviceableState);
    mainContainer.classList.add(classMynpcServiceableState);

    mynpcDisableInputCode(mainContainer);
  }

  //
  //

  function mynpcSwitchToUnserviceableState(mainContainer) {
    mainContainer.classList.remove(classMynpcCheckState);
    mainContainer.classList.remove(classMynpcServiceableState);
    mainContainer.classList.add(classMynpcUnserviceableState);

    mynpcDisableInputCode(mainContainer);

    var inputCodeText = mainContainer.querySelector(selectorMynpcInputCodeText);
    inputCodeText.innerText = mynpcInputCodeTextUnserviceableState;
    inputCodeText.classList.add(classMynpcInputCodeTextError);
  }

  //
  //
  //

  function mynpcInitEventHandlers() {
    var deliveryFormEles = document.querySelectorAll(selectorMynpcDeliveryForm);

    var index = 0;
    while (index < deliveryFormEles.length) {
      var deliveryForm = deliveryFormEles[index];

      deliveryForm.onsubmit = function (event) {
        event.preventDefault();
        mynpcProcessFormSubmit(this);
      }

      index += 1;
    }

    //

    var codeInputEles = document.querySelectorAll(selectorMynpcDeliveryFormCodeInput);

    var index = 0;
    while (index < codeInputEles.length) {
      var codeInput = codeInputEles[index];

      codeInput.onchange = function (event) {
        return mynpcProcessFormPincodeInput(this);
      }
      codeInput.onkeyup = function (event) {
        return mynpcProcessFormPincodeInput(this);
      }

      index += 1;
    }

    //

    var changeCodeButtonEles = document.querySelectorAll(selectorMynpcChangeCodeButton);

    var index = 0;
    while (index < changeCodeButtonEles.length) {
      var changeCodeButton = changeCodeButtonEles[index];

      changeCodeButton.addEventListener("click", function (event) {
        event.preventDefault();

        var mainContainer = this.closest(selectorMynpcMainContainer);

        mynpcSwitchToCheckState(mainContainer);
      });

      index += 1;
    }
  }

  //
  //

  function mynpcProcessFormSubmit(form) {
    var mainContainer = form.closest(selectorMynpcMainContainer);

    var pincode = form.querySelector(selectorMynpcDeliveryFormCodeInput).value;

    var pincodeInt = parseInt(pincode, 10);
    const pincodeToCheck = pincodeInt.toString();

    if (isNaN(pincodeInt) || pincodeToCheck.length !== 6) {
      mynpcShowErrorMsg(mainContainer, mynpcInvalidPincodeMsg);
      return;
    }

    //

    var httpRequest = new XMLHttpRequest();
    var httpRequestUrl = "https://api.theshimmerhouse.in/delivery/pincodes/" + pincodeToCheck;

    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState !== 4) {
        return;
      }

      mynpcSavePincode(pincodeToCheck);

      if (httpRequest.status === 200) {
        var respJson = JSON.parse(httpRequest.responseText);
        mynpcSwitchToServiceableState(mainContainer, respJson);
        return;
      }

      if (httpRequest.status === 404) {
        mynpcSwitchToUnserviceableState(mainContainer);
        return;
      }

      if (httpRequest.status === 400) {
        mynpcShowErrorMsg(mainContainer, mynpcInvalidPincodeMsg);
        return;
      }

      mynpcShowErrorMsg(mainContainer, mynpcPlsTryAgainMsg);
    }

    httpRequest.open("GET", httpRequestUrl, true);
    httpRequest.send(null);
  }

  //

  function mynpcProcessFormPincodeInput(codeInput) {
    var value = codeInput.value,
      valueInt = parseInt(value, 10);

    if (!isNaN(valueInt) && valueInt) {
      value = valueInt.toString();

      if (value.length <= mynpcPincodeLen) {
        codeInput.value = value;
      } else {
        codeInput.value = value.substring(0, mynpcPincodeLen);
      }

      return true;
    }

    if ('' === value) {
      codeInput.value = value;
      return true;
    }

    codeInput.value = '';
    return false;
  }

  //
  //
  //

  function mynpcGetFormattedDate(daysToAdd) {
    var today = new Date();
    var reqDate = new Date(new Date().setDate(today.getDate() + daysToAdd));

    var wk = new Intl.DateTimeFormat('en', { weekday: 'short' }).format(reqDate);
    var mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(reqDate);
    var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(reqDate);

    return `${wk}, ${mo} ${da}`;
  }

  //
  //

  function mynpcSavePincode(pincode) {
    try {
      localStorage.setItem(storageKeyMynpcPincode, pincode);
    } catch (error) {
    }

    sessionStorage.setItem(storageKeyMynpcPincode, pincode);
  }

  function mynpcReadSavedPincode() {
    const savedPincode = sessionStorage.getItem(storageKeyMynpcPincode);
    if (savedPincode !== null) {
      return savedPincode;
    }

    try {
      return localStorage.getItem(storageKeyMynpcPincode);
    } catch (error) {
      return null;
    }
  }

  function mynpcRemoveSavedPincode() {
    try {
      localStorage.removeItem(storageKeyMynpcPincode);
    } catch (error) {
    }

    sessionStorage.removeItem(storageKeyMynpcPincode);
  }

  //
  //
  //

  function initMynpc() {
    mynpcInitEventHandlers();

    var mynpcMainContainers = document.querySelectorAll(selectorMynpcMainContainer);
    var mmcIndex = 0;
    while (mmcIndex < mynpcMainContainers.length) {
      var mynpcMainContainer = mynpcMainContainers[mmcIndex];
      mynpcMainContainer.classList.remove(classMynpcHide);

      mmcIndex += 1;
    }

    const mynpcSavedPincode = mynpcReadSavedPincode();
    if (mynpcSavedPincode !== null) {
      var mynpcCodeInputEles = document.querySelectorAll(selectorMynpcDeliveryFormCodeInput);

      var mciIndex = 0;
      while (mciIndex < mynpcCodeInputEles.length) {
        var mynpcCodeInput = mynpcCodeInputEles[mciIndex];
        mynpcCodeInput.value = mynpcSavedPincode;

        var mynpcCheckCodeButton = mynpcCodeInput.parentElement.querySelector(selectorMynpcCheckCodeButton);
        mynpcCheckCodeButton.click();

        mciIndex += 1;
      }
    }
  }

  /* --- Pincode Checker - End --- */

  //
  //
  //
  //
  //

  /* --- Pagination - Load more - Start --- */

  function pgLoadMoreInitEventHandlers() {
    const queryPgRowNext = 'a.pagination__next';
    const queryProductList = '.collection-listing .product-list';
    const dataAttrNextUrlKey = 'data-cil-next-url';
    const dataAttrProductId = 'data-product-id';

    const pgRow = document.querySelector('.pagination-row');
    const loadMoreContainer = document.querySelector('.custom-il-pg-load-more-container');

    var pgRowNext = null;
    if (pgRow !== null) {
      pgRowNext = pgRow.querySelector(queryPgRowNext);
    }

    var productListContainer = document.querySelector(queryProductList);

    if (pgRowNext !== null && productListContainer != null && loadMoreContainer != null) {
      const loadMoreInfoCountDisplayed = loadMoreContainer.querySelector('.custom-il-count-displayed');
      const loadMoreButton = loadMoreContainer.querySelector('button');

      //

      loadMoreButton.addEventListener("click", function (event) {
        event.preventDefault();
        loadMoreButton.disabled = true;

        //

        var nextUrl = loadMoreButton.getAttribute(dataAttrNextUrlKey);
        if (nextUrl === "false") {
          loadMoreContainer.classList.add(classHide);
          return;
        }

        if (nextUrl === null) {
          pgRowNext = pgRow.querySelector(queryPgRowNext);
          nextUrl = pgRowNext.href;
        }

        //

        productListContainer = document.querySelector(queryProductList);

        $.get(nextUrl, function (response) {
          var $newHtml = $($.parseHTML('<div>' + response + '</div>', document, true));

          //

          var $newProducts = $newHtml.find('.collection-listing .product-list > div');

          $newProducts.each(function (idx, li) {
            var $newProduct = $(li);
            var newProductDataId = $newProduct.attr(dataAttrProductId);

            productListContainer.append($newProduct[0]);

            var selectorNewProduct = '[data-product-id="%s"]'.replace('%s', newProductDataId);
            var newProductEle = productListContainer.querySelector(selectorNewProduct);

            theme.loadCarousels(newProductEle);
            theme.ProductBlockManager.loadImages(newProductEle);
          });

          //

          var newNextUrl = 'false';

          var $newPgRowNext = $newHtml.find('.pagination-row a.pagination__next');
          if ($newPgRowNext.length > 0) {
            newNextUrl = $newPgRowNext[0].href;
          }

          loadMoreButton.setAttribute(dataAttrNextUrlKey, newNextUrl);

          //

          theme.initAnimateOnScroll();
        }).always(function () {
          if (loadMoreInfoCountDisplayed) {
            loadMoreInfoCountDisplayed.textContent =
              productListContainer.querySelectorAll('.product-block').length;
          }

          var nextUrl = loadMoreButton.getAttribute(dataAttrNextUrlKey);
          if (nextUrl === "false") {
            loadMoreContainer.classList.add(classHide);
          } else {
            loadMoreButton.disabled = false;
          }
        });
      });

      //

      const pgRowObserver = new MutationObserver(function (mutations) {
        var pgRowNext = pgRow.querySelector(queryPgRowNext);
        if (pgRowNext === null) {
          loadMoreContainer.classList.add(classHide);
          return;
        }

        //

        loadMoreButton.setAttribute(dataAttrNextUrlKey, pgRowNext.href);
        loadMoreContainer.classList.remove(classHide);
        loadMoreButton.disabled = false;
      });

      pgRowObserver.observe(pgRow, {
        childList: true,
        subtree: true,
      });

      //

      loadMoreContainer.classList.remove(classHide);
    }
  }

  //
  //
  //

  function initPgLoadMore() {
    pgLoadMoreInitEventHandlers();
  }

  /* --- Pagination - Load more - End --- */

  //
  //
  //
  //
  //

  /* --- Offers - Start --- */

  function offersInitEventHandlers() {
    const selectorOffersContainer = '.custom-il-offers-container',
      selectorNotificationContainer = '.custom-il-notification-container',
      selectorNotificationText = '.custom-il-notification-text',
      selectorTinySlideContainer = '.custom-il-offers-box',
      selectorOfferCode = '.custom-il-offer-code';

    const offersContainer = document.querySelector(selectorOffersContainer);
    if (!offersContainer) {
      return;
    }

    const notificationContainer = offersContainer.querySelector(selectorNotificationContainer),
      notificationText = offersContainer.querySelector(selectorNotificationText);

    //

    const copyCodeToClipboard = async (text, event) => {
      event.preventDefault();
      try {
        await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error('Unable to copy to clipboard: ', err);
      }
    }

    const showNotification = (msg) => {
      notificationText.innerText = msg;

      notificationContainer.classList.remove(classHide);
      setTimeout(function () {
        notificationContainer.classList.add(classHide);
      }, 3000);
    }

    //

    let sliderPromise = new Promise(function (sliderResolve) {
      const slider = tns({
        container: selectorTinySlideContainer,
        items: 2.4,
        slideBy: 1,
        gutter: 50,
        center: false,
        nav: false, controls: false,
        mouseDrag: true,
        swipeAngle: false,
        speed: 400,
        loop: false,
        preventScrollOnTouch: 'auto',
        responsive: {
          0: {
            items: 1.5,
            gutter: 30
          },
          440: {
            items: 2.4,
            gutter: 40
          },
          768: {
            items: 1.5,
            gutter: 30
          },
          960: {
            items: 2.4,
            gutter: 40
          }
        },
      });

      sliderResolve(slider.getInfo().container);
    });

    sliderPromise.then(function (sliderContainer) {
      const codeElements = document.querySelectorAll(selectorOfferCode);

      codeElements.forEach(function (element) {
        element.addEventListener('click', function (event) {
          const code = event.currentTarget.getAttribute('data-code');
          copyCodeToClipboard(code, event);

          //

          var msg = "Copied to Clipboard - " + code;
          showNotification(msg);
        });
      });

      //

      offersContainer.classList.remove(classHide);
    });
  }

  //
  //
  //

  function initOffers() {
    offersInitEventHandlers();
  }

  /* --- Offers - End --- */

  //
  //
  //
  //
  //

  /* --- Line Item Properties - Start --- */

  function lineItemPropsInitDisplayEventHandlers() {
    const propBlock = document.querySelector('.custom-il-li-prop-block');
    if (!propBlock) {
      return;
    }

    //

    const legendTextSize = 'size',
      legendTextTopSize = 'top-size',
      legendTextBottomSize = 'bottom-size';

    var mainSizeFieldsetTemp = null;
    var mainTopSizeFieldsetTemp = null;
    var mainBottomSizeFieldsetTemp = null;
    const mainOptionFieldsets = document.querySelectorAll('.option-selectors fieldset');
    for (const fieldset of mainOptionFieldsets) {
      const legend = fieldset.querySelector('legend.label');
      if (!legend) {
        continue;
      }

      const legendText = legend.textContent.trim().toLowerCase();

      if (legendText === legendTextSize) {
        mainSizeFieldsetTemp = fieldset;
        continue;
      }

      if (legendText === legendTextTopSize) {
        mainTopSizeFieldsetTemp = fieldset;
        continue;
      }

      if (legendText === legendTextBottomSize) {
        mainBottomSizeFieldsetTemp = fieldset;
        continue;
      }
    }

    const mainSizeFieldset = mainSizeFieldsetTemp;
    const mainTopSizeFieldset = mainTopSizeFieldsetTemp;
    const mainBottomSizeFieldset = mainBottomSizeFieldsetTemp;

    //

    if (mainSizeFieldset) {
      mainSizeFieldset.querySelectorAll('label').forEach(label => {
        label.addEventListener('click', function () {
          const sizeValue = this.querySelector('span').textContent.trim().toLowerCase();
          if (sizeValue !== productOptionValueCustom) {
            lineItemPropsHidePropBlock(propBlock);
            return;
          }

          lineItemPropsShowPropBlock(propBlock, true);
        });
      });

      lineItemPropsInitialDisplayHandling(mainSizeFieldset, propBlock);

      return;
    }

    if (mainTopSizeFieldset && mainBottomSizeFieldset) {
      const productForm = document.querySelector('.product-form');

      mainTopSizeFieldset.querySelectorAll('label').forEach(label => {
        lineItemPropsHandleDisplayForSetProduct(label, propBlock, mainBottomSizeFieldset, productForm);
      });

      mainBottomSizeFieldset.querySelectorAll('label').forEach(label => {
        lineItemPropsHandleDisplayForSetProduct(label, propBlock, mainTopSizeFieldset, productForm);
      });

      lineItemPropsInitialDisplayHandling(mainTopSizeFieldset, propBlock);
    }
  }

  function lineItemPropsInitialDisplayHandling(fieldset, propBlock) {
    const curSelectedLabel = fieldset.querySelector('.opt-btn:checked + label');
    if (curSelectedLabel) {
      const curSizeValue = curSelectedLabel.querySelector('span').textContent.trim().toLowerCase();
      if (curSizeValue === productOptionValueCustom) {
        lineItemPropsShowPropBlock(propBlock, true);
      }
    }
  }

  //

  function lineItemPropsHandleDisplayForSetProduct(label, propBlock, otherFieldSet, productForm) {
    label.addEventListener('click', function () {
      const sizeValue = this.querySelector('span').textContent.trim().toLowerCase();
      if (sizeValue !== productOptionValueCustom) {
        // Select the first option for other size if required
        const selectedLabelOfOtherSize = otherFieldSet.querySelector('.opt-btn:checked + label');
        if (selectedLabelOfOtherSize) {
          const curSizeValue = selectedLabelOfOtherSize.querySelector('span').textContent.trim().toLowerCase();
          if (curSizeValue === productOptionValueCustom) {
            const labelForOtherSize = otherFieldSet.querySelector('label');
            commonSelectOptionLabel(labelForOtherSize, productForm);
          }
        }

        lineItemPropsHidePropBlock(propBlock);
        return;
      }

      //

      // Select the custom option for other size
      const labelForOtherSize = [...otherFieldSet.querySelectorAll('label')].find(label => {
        const sizeValue = label.querySelector('span').textContent.trim().toLowerCase();
        return sizeValue === productOptionValueCustom;
      });
      commonSelectOptionLabel(labelForOtherSize, productForm);

      lineItemPropsShowPropBlock(propBlock, true);
    });
  }

  //
  //

  function lineItemPropsShowPropBlock(propBlock, triggerChange) {
    propBlock.classList.remove(classHide);

    if (triggerChange) {
      lineItemPropsTriggerChangeEvents();
    }
  }

  function lineItemPropsHidePropBlock(propBlock) {
    propBlock.classList.add(classHide);

    lineItemPropsRemoveCustomAtcInputs();
  }

  //

  function lineItemPropsTriggerChangeEvents() {
    const measurementsContainer = document.querySelector('.custom-il-li-prop-block .custom-il-measurements');
    if (!measurementsContainer) {
      return;
    }

    measurementsContainer.querySelectorAll('.custom-il-input, .custom-il-textarea').forEach(element => {
      element.dispatchEvent(new Event('change'));
    });
  }

  function lineItemPropsRemoveCustomAtcInputs() {
    const mainAtc = document.querySelector(selectorMainAtc);
    if (!mainAtc) {
      return;
    }

    mainAtc.querySelectorAll('.custom-il-li-prop-input').forEach(element => {
      element.remove();
    });
  }

  //
  //
  //

  function lineItemPropsInitFormEventHandlers() {
    const propNameChest = "Chest",
      propNameWaist = "Waist",
      propNameHips = "Hips",
      propNameOtherNotes = "Other Notes";

    const storageKeyChestVal = "li_prop_chest_val",
      storageKeyChestUnit = "li_prop_chest_unit",
      storageKeyWaistVal = "li_prop_waist_val",
      storageKeyWaistUnit = "li_prop_waist_unit",
      storageKeyHipsVal = "li_prop_hips_val",
      storageKeyHipsUnit = "li_prop_hips_unit",
      storageKeyOtherNotesVal = "li_prop_other_notes_val";

    //
    //

    const mainAtc = document.querySelector(selectorMainAtc);
    const propBoxes = document.querySelectorAll('.custom-il-li-prop-box[data-cil-prop-name]');
    if (!mainAtc || !propBoxes) {
      return;
    }

    propBoxes.forEach(box => {
      const dataPropName = box.getAttribute('data-cil-prop-name').trim();
      if (dataPropName == '') {
        return;
      }

      const propName = `properties[${dataPropName}]`;

      const input = box.querySelector('.custom-il-input');
      const select = box.querySelector('.custom-il-select');
      const textarea = box.querySelector('.custom-il-textarea');

      //
      //

      if (input && select) {
        // Data validation
        input.addEventListener('input', function () {
          const ogValue = this.value;
          let value = ogValue;

          // Check if there's more than one decimal point
          const decimalCount = (value.match(/\./g) || []).length;
          if (decimalCount > 1) {
            // Remove everything from the second decimal onwards
            let secondDecimalIndex = value.indexOf('.', value.indexOf('.') + 1);
            value = value.substring(0, secondDecimalIndex);
          }

          // Remove any characters that aren't digits or the period (.)
          value = value.replace(/[^\d\.]/g, '');

          // Limit decimal points
          let floatValue = parseFloat(value);
          let roundedValue = parseFloat(floatValue.toFixed(2));
          if (floatValue !== roundedValue) {
            value = roundedValue;
          }

          // Handle zero
          if (parseFloat(value) === 0) {
            value = "";
          }

          // Limit upper value
          const maxValue = parseFloat(this.getAttribute('max'));
          if (parseFloat(value) > maxValue) {
            value = maxValue;
          }

          if (parseFloat(ogValue) !== parseFloat(value)) {
            this.value = value;
          }
        });

        //
        //

        input.addEventListener('change', function () {
          let inputValue = this.value.trim();
          if (inputValue == '') {
            box.setAttribute(dataAttrValInputted, 0);
            lineItemPropsUpdateMainAtc(mainAtc, propName, '');

            // Remove from storage
            switch (dataPropName) {
              case propNameChest:
                commonRemoveFromStorge(storageKeyChestVal);
                commonRemoveFromStorge(storageKeyChestUnit);
                break;

              case propNameWaist:
                commonRemoveFromStorge(storageKeyWaistVal);
                commonRemoveFromStorge(storageKeyWaistUnit);
                break;

              case propNameHips:
                commonRemoveFromStorge(storageKeyHipsVal);
                commonRemoveFromStorge(storageKeyHipsUnit);
                break;

              default:
                break;
            }
            return;
          }

          //

          inputValue = lineItemPropsParseInputValue(inputValue);

          const selectValue = select.value;

          const mergedValue = inputValue + " " + selectValue;

          box.setAttribute(dataAttrValInputted, 1);
          box.classList.remove(classErrorReq);
          lineItemPropsUpdateMainAtc(mainAtc, propName, mergedValue);

          //

          // Save in storage
          switch (dataPropName) {
            case propNameChest:
              commonSaveInStorage(storageKeyChestVal, inputValue);
              commonSaveInStorage(storageKeyChestUnit, selectValue);
              break;

            case propNameWaist:
              commonSaveInStorage(storageKeyWaistVal, inputValue);
              commonSaveInStorage(storageKeyWaistUnit, selectValue);
              break;

            case propNameHips:
              commonSaveInStorage(storageKeyHipsVal, inputValue);
              commonSaveInStorage(storageKeyHipsUnit, selectValue);
              break;

            default:
              break;
          }
        });

        //

        select.addEventListener('change', function () {
          const selectValue = this.value;

          let inputValue = input.value.trim();
          if (inputValue == '') {
            return;
          }

          //

          inputValue = lineItemPropsParseInputValue(inputValue);

          const mergedValue = inputValue + " " + selectValue;

          lineItemPropsUpdateMainAtc(mainAtc, propName, mergedValue);

          //

          // Save in storage
          switch (dataPropName) {
            case propNameChest:
              commonSaveInStorage(storageKeyChestVal, inputValue);
              commonSaveInStorage(storageKeyChestUnit, selectValue);
              break;

            case propNameWaist:
              commonSaveInStorage(storageKeyWaistVal, inputValue);
              commonSaveInStorage(storageKeyWaistUnit, selectValue);
              break;

            case propNameHips:
              commonSaveInStorage(storageKeyHipsVal, inputValue);
              commonSaveInStorage(storageKeyHipsUnit, selectValue);
              break;

            default:
              break;
          }
        });
      }

      //

      if (textarea) {
        // Data validation
        textarea.addEventListener('input', function () {
          let value = this.value;

          // Limit upper value
          const maxLen = parseFloat(this.getAttribute('max'));
          if (value.length > maxLen) {
            this.value = value.substring(0, maxLen);
          }
        });

        //
        //

        textarea.addEventListener('change', function () {
          const value = this.value.trim();
          if (value == '') {
            lineItemPropsUpdateMainAtc(mainAtc, propName, '');

            // Remove from storage
            switch (dataPropName) {
              case propNameOtherNotes:
                commonRemoveFromStorge(storageKeyOtherNotesVal);
                break;

              default:
                break;
            }
            return;
          }

          //

          lineItemPropsUpdateMainAtc(mainAtc, propName, value);

          //

          // Save in storage
          switch (dataPropName) {
            case propNameOtherNotes:
              commonSaveInStorage(storageKeyOtherNotesVal, value);
              break;

            default:
              break;
          }
        });
      }
    });

    //
    //

    const propBoxChest = document.querySelector(`.custom-il-li-prop-box[data-cil-prop-name="${propNameChest}"]`);
    lineItemPropsRestoreInputGroup(propBoxChest, storageKeyChestVal, storageKeyChestUnit)

    const propBoxWaist = document.querySelector(`.custom-il-li-prop-box[data-cil-prop-name="${propNameWaist}"]`);
    lineItemPropsRestoreInputGroup(propBoxWaist, storageKeyWaistVal, storageKeyWaistUnit)

    const propBoxHips = document.querySelector(`.custom-il-li-prop-box[data-cil-prop-name="${propNameHips}"]`);
    lineItemPropsRestoreInputGroup(propBoxHips, storageKeyHipsVal, storageKeyHipsUnit)

    const propBoxOtherNotes = document.querySelector(`.custom-il-li-prop-box[data-cil-prop-name="${propNameOtherNotes}"]`);
    lineItemPropsRestoreTextArea(propBoxOtherNotes, storageKeyOtherNotesVal)

  }

  function lineItemPropsUpdateMainAtc(mainAtc, name, value) {
    let hiddenInput = mainAtc.querySelector(`input[type="hidden"][name="${name}"]`);
    if (hiddenInput) {
      if (value == '') {
        hiddenInput.parentNode.removeChild(hiddenInput);
      }
    } else {
      if (value == '') {
        return;
      }

      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = name;
      hiddenInput.classList.add('custom-il-li-prop-input');
      mainAtc.appendChild(hiddenInput);
    }

    hiddenInput.value = value;
  }

  function lineItemPropsParseInputValue(value) {
    value = parseFloat(value).toFixed(2);

    // If the decimal part is .00, convert back to integer
    if (value.endsWith('.00')) {
      value = parseInt(value, 10);
    }

    return value;
  }

  //
  //

  function lineItemPropsRestoreInputGroup(propBox, keyVal, keyUnit) {
    if (!propBox) {
      return
    }

    const savedVal = commonReadFromStorage(keyVal);
    const savedUnit = commonReadFromStorage(keyUnit);
    if (!savedVal || !savedUnit) {
      return;
    }

    const input = propBox.querySelector('.custom-il-input');
    const select = propBox.querySelector('.custom-il-select');
    if (!input || !select) {
      return;
    }

    //

    input.value = savedVal;
    select.value = savedUnit;
  }

  function lineItemPropsRestoreTextArea(propBox, keyVal) {
    if (!propBox) {
      return
    }

    const savedVal = commonReadFromStorage(keyVal);
    if (!savedVal) {
      return;
    }

    const textarea = propBox.querySelector('.custom-il-textarea');
    if (!textarea) {
      return;
    }

    //

    textarea.value = savedVal;
  }

  //
  //
  //

  function lineItemPropsValidateForMainAtc() {
    const propBlock = document.querySelector('.custom-il-li-prop-block');
    if (!propBlock) {
      return true;
    }

    if (propBlock.classList.contains(classHide)) {
      return true;
    }

    //
    //

    const emptyValPropBoxes = propBlock.querySelectorAll(`.custom-il-li-prop-box[${dataAttrValInputted}="0"]`);
    if (!emptyValPropBoxes || emptyValPropBoxes.length == 0) {
      return true;
    }

    emptyValPropBoxes.forEach(emptyValPropBox => {
      emptyValPropBox.classList.add(classErrorReq);
    });
    theme.scrollToRevealElement(emptyValPropBoxes[0]);

    return false;
  }

  //
  //
  //

  function initLineItemProps() {
    lineItemPropsInitFormEventHandlers();

    lineItemPropsInitDisplayEventHandlers();
  }

  /* --- Line Item Properties - End --- */

  //
  //
  //
  //
  //

  /* --- Product Sticky Form - Start --- */

  class CustomInternalProductStickyForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    connectedCallback() {
      this._setupVisibilityObservers();

      this._setupMutationObservers();
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      if (this.mainAtcButtonMutationObserver) {
        this.mainAtcButtonMutationObserver.disconnect();
      }
      if (this.mainPriceBoxMutationObserver) {
        this.mainPriceBoxMutationObserver.disconnect();
      }
      if (this.gallerySlideshowMutationObserver) {
        this.gallerySlideshowMutationObserver.disconnect();
      }
    }

    init() {
      const mainAtc = document.querySelector(selectorMainAtc);
      if (mainAtc) {
        const mainAtcButton = mainAtc.querySelector('button[type="submit"]');
        const atcButton = this.querySelector('.custom-il-atc-button');

        if (mainAtcButton && atcButton) {
          atcButton.addEventListener('click', function (e) {
            e.preventDefault();

            mainAtcButton.click();
          });
        }
      }

      //
      //

      const productForm = document.querySelector('.product-form');

      //

      const selectorSize = this.querySelector('.custom-il-options-container select');

      var mainSizeFieldsetTemp = null;
      const mainOptionFieldsets = document.querySelectorAll('.option-selectors fieldset');
      for (const fieldset of mainOptionFieldsets) {
        const legend = fieldset.querySelector('legend.label');
        if (legend && legend.textContent.trim().toLowerCase() === 'size') {
          mainSizeFieldsetTemp = fieldset;
          break;
        }
      }
      const mainSizeFieldset = mainSizeFieldsetTemp;

      if (selectorSize && mainSizeFieldset) {
        selectorSize.addEventListener('change', function () {
          const selectedValue = this.value.toLowerCase();
          const correspondingLabel = [...mainSizeFieldset.querySelectorAll('label')].find(label => {
            const sizeValue = label.querySelector('span').textContent.trim().toLowerCase();
            return sizeValue === selectedValue;
          });

          commonSelectOptionLabel(correspondingLabel, productForm);
        });

        //

        mainSizeFieldset.querySelectorAll('label').forEach(label => {
          label.addEventListener('click', function () {
            const sizeValue = this.querySelector('span').textContent.trim().toLowerCase();
            const optionToSelect = [...selectorSize.querySelectorAll('option')].find(option => {
              return option.value.toLowerCase() === sizeValue;
            });

            if (optionToSelect) {
              optionToSelect.selected = true;
            }
          });
        });
      }
    }

    //

    _setupVisibilityObservers() {
      const classFormVisible = 'custom-il-pd-sticky-form-visible';

      const body = document.body;
      const mainAtc = document.querySelector(selectorMainAtc);
      const footer = document.getElementById('pagefooter');
      const stickyHeaderOffset = document.getElementById('shopify-section-header').offsetHeight;

      this._isFooterVisible = false;
      this._isMainAtcPassed = false;

      if (mainAtc && footer && stickyHeaderOffset) {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                this._isFooterVisible = entry.intersectionRatio > 0;
                return;
              }

              if (entry.target === mainAtc) {
                const boundingRect = mainAtc.getBoundingClientRect();
                this._isMainAtcPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
                return;
              }
            });

            //

            let mobileMedia = false;

            for (const media of theme.settings.custom_fields.mobile.media) {
              if (window.matchMedia(media).matches) {
                mobileMedia = true;
                break;
              }
            }

            if (mobileMedia) {
              this.hidden = !this._isMainAtcPassed || this._isFooterVisible;
            } else {
              this.hidden = !this._isMainAtcPassed;
            }

            if (this.hidden) {
              body.classList.remove(classFormVisible);
            } else {
              body.classList.add(classFormVisible);
            }
          },
          { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` });

        this.intersectionObserver.observe(mainAtc);
        this.intersectionObserver.observe(footer);
      }
    }

    _setupMutationObservers() {
      const classWorking = 'working';
      const classSoldOut = 'button--sold-out';

      const atcButton = this.querySelector('.custom-il-atc-button');

      //
      //

      const mainAtc = document.querySelector(selectorMainAtc);
      if (mainAtc) {
        const mainAtcButton = mainAtc.querySelector('button[type="submit"]');

        if (mainAtcButton && atcButton) {
          const atcButtonText = atcButton.querySelector('.custom-il-text');

          this.mainAtcButtonMutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              switch (mutation.type) {
                case 'attributes':
                  if (mutation.attributeName === 'disabled') {
                    if (mainAtcButton.hasAttribute('disabled')) {
                      atcButton.classList.add(classWorking);
                      atcButton.disabled = true;
                    } else {
                      atcButton.classList.remove(classWorking);
                      atcButton.disabled = false;
                    }
                  }
                  break;
                case 'childList':
                  var disableButton = mainAtcButton.hasAttribute('disabled')
                    || mainAtcButton.classList.contains(classSoldOut);
                  if (disableButton) {
                    atcButton.disabled = true;
                  } else {
                    atcButton.disabled = false;
                  }

                  atcButtonText.textContent = mainAtcButton.textContent;
                  break;

                default:
                  break;
              }
            });
          });

          this.mainAtcButtonMutationObserver.observe(
            mainAtcButton,
            {
              attributes: true,
              attributeFilter: ['disabled'],
              childList: true
            }
          );
        }
      }

      //
      //

      const mainPriceBox = document.querySelector('.price-container .variant-visibility-area');

      if (mainPriceBox && atcButton) {
        const atcButtonPrice = atcButton.querySelector('.custom-il-price');
        const atcButtonSeparator = atcButton.querySelector('.custom-il-separator');

        if (atcButtonPrice && atcButtonSeparator) {
          this.mainPriceBoxMutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              switch (mutation.type) {
                case 'childList':
                  const mainCurrentPrice = mainPriceBox.querySelector('.price-area .price .current-price');

                  atcButtonPrice.textContent = mainCurrentPrice.textContent;

                  if (atcButtonPrice.textContent.trim() === "") {
                    atcButtonPrice.classList.add(classHide);
                    atcButtonSeparator.classList.add(classHide);
                  } else {
                    atcButtonPrice.classList.remove(classHide);
                    atcButtonSeparator.classList.remove(classHide);
                  }

                  //

                  const variantInputField = document.querySelector('.price-descriptors .shopify-product-form input[name="id"]');
                  if (variantInputField) {
                    const curVariantId = variantInputField.value;

                    //

                    const atcButtonInfoBox = atcButton.querySelector('.custom-il-extra-data .custom-il-info-box');
                    const atcButtonTemplateBox = atcButton.querySelector('.custom-il-extra-data .custom-il-template-box');
                    if (atcButtonInfoBox && atcButtonTemplateBox) {
                      const atcButtonInfo = atcButtonInfoBox.querySelector('.custom-il-info');
                      if (atcButtonInfo) {
                        const atcButtonInfoTemplate = atcButtonTemplateBox.querySelector('template[data-variant-id="' + curVariantId + '"]');
                        if (atcButtonInfoTemplate) {
                          atcButtonInfo.textContent = atcButtonInfoTemplate.getAttribute('data-cil-sale-label-text');

                          atcButtonInfoBox.classList.remove(classHide);
                        } else {
                          atcButtonInfoBox.classList.add(classHide);
                        }
                      }
                    }

                    //

                    const transparentPricingBox = document.querySelector('.custom-il-pd-transparent-pricing-box');
                    if (transparentPricingBox) {
                      const pricingTemplate = transparentPricingBox.querySelector('template[data-variant-id="' + curVariantId + '"]');
                      if (pricingTemplate) {
                        const pricingCost01 = transparentPricingBox.querySelector('.custom-il-value-cost-01');
                        if (pricingCost01) {
                          pricingCost01.textContent = pricingTemplate.getAttribute('data-cil-cost-01');
                        }

                        const pricingCost02 = transparentPricingBox.querySelector('.custom-il-value-cost-02');
                        if (pricingCost02) {
                          pricingCost02.textContent = pricingTemplate.getAttribute('data-cil-cost-02');
                        }

                        const pricingCost03 = transparentPricingBox.querySelector('.custom-il-value-cost-03');
                        if (pricingCost03) {
                          pricingCost03.textContent = pricingTemplate.getAttribute('data-cil-cost-03');
                        }

                        const pricingCost04 = transparentPricingBox.querySelector('.custom-il-value-cost-04');
                        if (pricingCost04) {
                          pricingCost04.textContent = pricingTemplate.getAttribute('data-cil-cost-04');
                        }

                        const pricingCost05 = transparentPricingBox.querySelector('.custom-il-value-cost-05');
                        if (pricingCost05) {
                          pricingCost05.textContent = pricingTemplate.getAttribute('data-cil-cost-05');
                        }

                        const pricingSelfPrice = transparentPricingBox.querySelector('.custom-il-value-self-price');
                        if (pricingSelfPrice) {
                          pricingSelfPrice.textContent = pricingTemplate.getAttribute('data-cil-tsh-price');
                        }

                        const pricingBarSelfLabelTop = transparentPricingBox.querySelector('.custom-il-bar.custom-il-self .custom-il-label-top');
                        if (pricingBarSelfLabelTop) {
                          pricingBarSelfLabelTop.textContent = pricingTemplate.getAttribute('data-cil-tsh-price');
                        }

                        const pricingBarOtherBrandsLabelTop = transparentPricingBox.querySelector('.custom-il-bar.custom-il-others .custom-il-label-top');
                        if (pricingBarOtherBrandsLabelTop) {
                          pricingBarOtherBrandsLabelTop.textContent = pricingTemplate.getAttribute('data-cil-other-brands-price');
                        }
                      }
                    }
                  }
                  break;

                default:
                  break;
              }
            });
          });

          this.mainPriceBoxMutationObserver.observe(
            mainPriceBox,
            {
              childList: true
            }
          );
        }
      }

      //
      //

      const gallerySlideshow = document.querySelector('.gallery .main-image .slideshow');
      const infoImg = this.querySelector('.custom-il-info-container img');

      if (gallerySlideshow && infoImg) {
        this.gallerySlideshowMutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            switch (mutation.type) {
              case 'childList':
                let retries = 0;
                (function attempt() {
                  const result = this._updateInfoImg(gallerySlideshow, infoImg);
                  if (result === false && retries < 20) {
                    retries++;
                    setTimeout(attempt.bind(this), 100);
                  }
                }).bind(this)();
                break;

              default:
                break;
            }
          });
        });

        this.gallerySlideshowMutationObserver.observe(
          gallerySlideshow,
          {
            childList: true
          }
        );
      }
    }

    _updateInfoImg(gallerySlideshow, infoImg) {
      const mainImg = gallerySlideshow.querySelector('img');
      if (!mainImg) {
        return false;
      }

      //

      let infoImgUrl = this._getImgURL(infoImg);
      let mainImgUrl = this._getImgURL(mainImg);

      if (!infoImgUrl || !mainImgUrl) {
        return false;
      }

      let imgUpdateReq = mainImgUrl.origin !== infoImgUrl.origin
        || mainImgUrl.pathname !== infoImgUrl.pathname
        || mainImgUrl.searchParams.get("v") !== infoImgUrl.searchParams.get("v");

      if (!imgUpdateReq) {
        return true;
      }

      //

      let newInfoImgUrlCommon = new URL(
        mainImgUrl.pathname,
        mainImgUrl.origin
      );

      let paramV = mainImgUrl.searchParams.get("v");
      if (paramV) {
        newInfoImgUrlCommon.searchParams.set("v", paramV);
      }

      //

      let newInfoImgSrcUrl = new URL(newInfoImgUrlCommon.toString());
      let newInfoImgSrcUrlUpdated = false;
      let newInfoImgSrcset = "";

      for (const img_src of theme.settings.custom_fields.sticky_atc.product.img.sources) {
        if (newInfoImgSrcset.length > 0) {
          newInfoImgSrcset += ", ";
        }

        let tempUrl;
        if (!newInfoImgSrcUrlUpdated) {
          tempUrl = newInfoImgSrcUrl;
          newInfoImgSrcUrlUpdated = true;
        } else {
          tempUrl = new URL(newInfoImgUrlCommon.toString());
        }

        let params = img_src.params;
        for (const param_key of Object.keys(params)) {
          tempUrl.searchParams.set(param_key, params[param_key]);
        }

        newInfoImgSrcset += tempUrl.toString() + " " + img_src.descriptor;
      }

      //

      infoImg.srcset = newInfoImgSrcset;
      infoImg.src = newInfoImgSrcUrl.toString();
    }

    _getImgURL(img) {
      const src = img.src;
      if (src && src.trim() !== '') {
        return new URL(window.location.protocol + src);
      }

      //

      const srcset = img.srcset;
      if (srcset) {
        const srcsetValues = srcset.split(', ');
        var lastURL = srcsetValues[srcsetValues.length - 1].split(' ')[0];
        lastURL = lastURL.replace(/_\d+x(?=\.)/, '')
        return new URL(window.location.protocol + lastURL);
      }

      //

      return null;
    }
  }

  customElements.define('custom-il-pd-sticky-form', CustomInternalProductStickyForm);

  /* --- Product Sticky Form - End --- */

  //
  //
  //
  //
  //

  /* --- Product Review - Start --- */

  async function productReviewModifyWrapper(jdgmRev) {
    if (jdgmRev.dataset.cilModified === 'true') {
      return;
    }

    //

    jdgmRev.dataset.cilModified = 'true';

    let taskComplete = false;
    let retryCount = 0;
    while (!taskComplete) {
      taskComplete = productReviewModify(jdgmRev);
      if (taskComplete) {
        return;
      }

      retryCount++;
      if (retryCount > 100) {
        jdgmRev.dataset.cilModified = 'failed';
        return;
      }

      await sleep(10);
    }
  }

  function productReviewModify(jdgmRev) {
    const jdgmRevHeader = jdgmRev.querySelector('.jdgm-rev__header');
    const jdgmRevContent = jdgmRev.querySelector('.jdgm-rev__content');
    const jdgmRevActions = jdgmRev.querySelector('.jdgm-rev__actions');

    if (!jdgmRevHeader || !jdgmRevContent || !jdgmRevActions) {
      return false;
    }

    const jdgmRowProduct = jdgmRevHeader.querySelector('.jdgm-row-product');
    const jdgmRowRating = jdgmRevHeader.querySelector('.jdgm-row-rating');
    let jdgmRowProfile = jdgmRevHeader.querySelector('.jdgm-row-profile');
    let jdgmRowExtra = jdgmRevHeader.querySelector('.jdgm-row-extra');
    let jdgmRevBr = jdgmRevHeader.querySelector('.jdgm-rev__br');
    const jdgmRevTitle = jdgmRevContent.querySelector('.jdgm-rev__title');

    if (!jdgmRowProduct || !jdgmRowRating || !jdgmRowProfile || !jdgmRowExtra || !jdgmRevBr || !jdgmRevTitle) {
      return false;
    }

    let jdgmRevRating = jdgmRowRating.querySelector('.jdgm-rev__rating');
    const jdgmRevTimestamp = jdgmRowRating.querySelector('.jdgm-rev__timestamp');

    if (!jdgmRevRating || !jdgmRevTimestamp) {
      return false;
    }

    //

    jdgmRowRating.appendChild(jdgmRevTitle);
    jdgmRowRating.appendChild(jdgmRevContent);
    jdgmRowRating.appendChild(jdgmRevActions);

    jdgmRevContent.appendChild(jdgmRowProduct);

    jdgmRevHeader.appendChild(jdgmRevTimestamp);

    //

    jdgmRev.querySelectorAll('.jdgm-rev__custom-form .jdgm-rev__cf-ans').forEach(function(answer) {
      const title = answer.querySelector('.jdgm-rev__cf-ans__title').textContent.trim().replace(":", "");
      const value = answer.querySelector('.jdgm-rev__cf-ans__value').textContent.trim();

      let config;

      switch (title) {
        case "Fit":
          config = {
            'Tight': { width: '33%', marginLeft: '0%' },
            'Fit': { width: '33%', marginLeft: '33%' },
            'Runs Large': { width: '34%', marginLeft: '66%' }
          };

          productReviewHandleQASlider1(jdgmRevContent, title, value, config[value]);
          break;

        case "Quality":
          config = {
            'Low': { width: '33%', marginLeft: '0%' },
            'Decent': { width: '33%', marginLeft: '33%' },
            'High': { width: '34%', marginLeft: '66%' }
          };

          productReviewHandleQASlider1(jdgmRevContent, title, value, config[value]);
          break;

        case "Size":
          productReviewHandleQASize(jdgmRowProduct, value);
          break;

        default:
          break;
      }
    });

    return true;
  }

  //
  //
  //

  function productReviewHandleQASize(jdgmRowProduct, value) {
    const infoWrapper = jdgmRowProduct.querySelector(".jdgm-rev__prod-info-wrapper");
    if (!infoWrapper) {
      return;
    }

    const prefix = infoWrapper.querySelector('.jdgm-rev__prod-link-prefix');
    const link = infoWrapper.querySelector('.jdgm-rev__prod-link');
    if (!prefix || !link) {
      return;
    }

    //

    let variantName = link.textContent.trim() + " - " + value;

    //

    prefix.textContent = "Product Reviewed:";

    link.textContent = variantName;
    link.title = variantName;

    infoWrapper.classList.remove('jdgm-hidden');
  }

  //
  //

  function productReviewHandleQASlider1(jdgmRevContent, title, value, currentConfig) {
    const attrLeft = `calc(${currentConfig.marginLeft} + (${currentConfig.width} / 2))`;

    const html = `
    <div class="question-wrapper">
      <div class="question-title" title="${title}">${title}</div>

      <div class="progress-bar-wrapper">
        <div class="progress-bar">
          <div class="progress-bar-score" style="width: ${currentConfig.width}; margin-left: ${currentConfig.marginLeft};"></div>
        </div>
      </div>

      <div title="${value}" class="question-value" style="left: ${attrLeft};">
        ${value}
      </div>
    </div>
    `;

    productReviewHandleQAGetContainer(jdgmRevContent).insertAdjacentHTML('beforeend', html);
  }

  //

  function productReviewHandleQAGetContainer(jdgmRevContent) {
    let container = jdgmRevContent.querySelector('.questions-container');
    if (container) {
      return container;
    }

    //

    container = document.createElement('div');
    container.className = 'questions-container';

    jdgmRevContent.appendChild(container);

    return container;
  }

  //
  //
  //

  function initProductReviews() {
    if (!theme.settings.custom_fields.product.reviews.modify ) {
      return;
    }

    const mainElement = document.querySelector('#judgeme_product_reviews');
    if (!mainElement) {
      return;
    }

    //

    mainElement.classList.add('custom-il-reviews-main-container');

    //

    const observer01 = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const element = mutation.target;

          if (element.classList.contains('jdgm-rev')) {
            productReviewModifyWrapper(element);
          }
        }
      }
    });

    observer01.observe(mainElement, {
      attributes: true,
      subtree: true
    });

    //

    const observer02 = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const jdgmRev = node.closest('.jdgm-rev');
              if (jdgmRev) {
                productReviewModifyWrapper(jdgmRev);
              }
            }
          });
        }
      }
    });

    observer02.observe(mainElement, {
      childList: true,
      subtree: true,
    });

    //
    //

    setTimeout(function () {
      mainElement.querySelectorAll('.jdgm-rev:not([data-cil-modified])').forEach(jdgmRev => {
        productReviewModifyWrapper(jdgmRev);
      });
    }, 50);
  }

  /* --- Product Review - End --- */

  //
  //
  //
  //
  //

  /* --- Main Add To Cart - Start --- */

  function initMainAtc() {
    const mainAtcForm = document.querySelector(selectorMainAtc);
    if (!mainAtcForm) {
      return;
    }

    mainAtcForm.addEventListener("submit", function (event) {
      if (!lineItemPropsValidateForMainAtc()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  /* --- Main Add To Cart - End --- */

  //
  //
  //
  //
  //

  /* --- Generic - Start --- */

  function initGeneric() {
    document.body.setAttribute('data-cil-dom-loaded', 'true');
  }

  /* --- Generic - End --- */

  //
  //
  //
  //
  //

  window.onload = function () {
    initGeneric();

    initMynpc();

    initPgLoadMore();

    initOffers();

    initLineItemProps();

    initMainAtc();

    initProductReviews();
  }
});